import { WalletconnectService, MetamaskService, CoinbaseService } from './wallets'

class Web3Service {
  constructor(
    public walletConnect: WalletconnectService,
    public metamaskService: MetamaskService,
    public coinbaseService: CoinbaseService
  ) {}

  clearConnection(): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key !== 'payment_token') {
        localStorage.removeItem(key as string)
      }
    }
  }
}

export default new Web3Service(new WalletconnectService(), new MetamaskService(), new CoinbaseService())
